import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import Icon from '../../partials/Icon';

export default class Student extends Component {
    state = {
        sold: 0
    }

    componentDidMount() {
        if (this.props.student.transactions.length) {
            var sold = _.sumBy(this.props.student.transactions, 'shares'); 
            this.setState({ sold });
        }
    }

    render() {
        const { student } = this.props;
        const shares = student.projects[0] ? student.projects[0].pivot.shares : null;

        return (
            <li>
                <Icon icon="user" color="pink" />
                <Link to={ `/admin/projects/${this.props.group_id}/${this.props.project_id}/${student.id}` }>{ student.first_name }</Link>
                <span className="right">{ shares === null ? `${ this.state.sold }/-` : `${ this.state.sold }/${ shares }` }</span>
            </li>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/admin/Project/Student.js